// src/components/shared/BadgeExplainer.js
// Modal explaining what each practitioner badge means.

import React from 'react';
import { VerifiedBadge, BackgroundCheckBadge, ExcellenceBadge } from './BadgeDisplay';

const BadgeExplainer = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const badges = [
    {
      Icon: VerifiedBadge,
      title: 'Verified',
      description: 'Identity confirmed. Profile reviewed by Divine Frameworks.',
    },
    {
      Icon: BackgroundCheckBadge,
      title: 'Background Checked',
      description: 'Passed a third-party background check.',
    },
    {
      Icon: ExcellenceBadge,
      title: 'Practitioner of Excellence',
      description: 'Personally recognized for exceptional professionalism by Divine Frameworks.',
    },
  ];

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: '16px',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: 'white', borderRadius: '16px', width: '100%', maxWidth: '420px',
        padding: '28px', fontFamily: "'Montserrat', sans-serif",
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ fontSize: '17px', fontWeight: 700, color: '#111827', margin: 0 }}>
            What do these badges mean?
          </h2>
          <span
            role="button"
            tabIndex={0}
            onClick={onClose}
            onKeyDown={(e) => e.key === 'Enter' && onClose()}
            style={{ fontSize: '20px', color: '#9CA3AF', cursor: 'pointer', userSelect: 'none', lineHeight: 1 }}
          >
            &times;
          </span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {badges.map(({ Icon, title, description }) => (
            <div key={title} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <div style={{ flexShrink: 0, marginTop: '1px' }}>
                <Icon size={22} />
              </div>
              <div>
                <p style={{ fontSize: '14px', fontWeight: 600, color: '#111827', margin: '0 0 2px 0' }}>
                  {title}
                </p>
                <p style={{ fontSize: '13px', color: '#6B7280', margin: 0, lineHeight: 1.5 }}>
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '24px', textAlign: 'center' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '9px 28px', border: 'none', borderRadius: '8px',
              background: '#7c3aed', color: 'white', fontSize: '13px',
              fontWeight: 600, cursor: 'pointer', fontFamily: "'Montserrat', sans-serif",
            }}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default BadgeExplainer;
